import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { compose } from 'redux';
import { createStructuredSelector } from 'reselect';
import styled from 'styled-components';
import { Button } from '../../../../components/Buttons';
import { Check, View } from '../../../../components/Icon';
import { Loader } from '../../../../components/Loader';
import { Modal, ModalControls } from '../../../../components/Modal';
import { VehicleAvatar } from '../../../../components/VehicleAvatar';
import { selectWorks } from '../../../Api/selectors';
import { VehicleHeader } from '../../../Vehicles/components/VehicleHeader';
import { performAction, refreshBoards } from '../../actions';
import {
  REQUEST_KANBAN_BOARD_PERFORM_ACTION,
  TASK_STATUS_ACTIVE,
  TASK_STATUS_INACTIVE,
  TASK_STATUS_PLAN,
} from '../../constants';
import { PerformActionButton } from '../PerformActionButton';
import { BaseCellComp } from '../BaseCellComp';
import { CompanyLabelById } from '../../../Companies/components/CompanyLabelById';
import { CellButton, CellButtons } from '../CellButton';
import { Well } from '../../../../components/Well';
import { VBox } from '../../../../components/Box';
import { Checkbox } from '../../../../components/Checkbox';
import { VehiclePropertyEditableInput } from '../../../Vehicles/components/VehiclePropertyEditableInput';
import { WithVehicle } from '../../../Vehicles/components/WithVehicle';
import { selectVehicle } from '../../../Vehicles/selectors';
import { List, Row, Cell } from '../../../../components/List';
import { Label, getLabelColor } from '../../../Vehicles/components/VehicleCounterLabel';

import { Cell as ActionCell } from '../Cell';
import { formatCurrency } from '../../../../utils/string';
import { updateInvoiceStatus } from '../../../Invoices/actions';

//change this for values of counters
const ranges = {
  MediumSeaGreen: [1, 3],
  DarkOrange: [4, 6],
  Crimson: [7, Infinity],
};

const Container = styled.div`
  .pane {
    padding: 24px 12px;

    .fields {
      margin-top: 24px;
    }

    h3 {
      margin-bottom: 12px;
    }

    h4 {
      margin-top: 24px;
      font-size: 20px;
    }
  }
`;

const STATE = {
  approve: false,
};

/* eslint-disable react/prefer-stateless-function */
class Valideren_gijsComp extends BaseCellComp {
  constructor(props) {
    super(props, { ...STATE });
  }

  componentDidMount() {}

  reset() {
    this.setState({ ...STATE });
  }

  get vehicle() {
    return this.props.vehicle || this.props.cell.vehicle;
  }

  render01(name) {
    return (
      <Checkbox
        key={name}
        checked={this.state[name] == TASK_STATUS_ACTIVE}
        onChange={() => {
          this.setState({ [name]: this.state[name] != TASK_STATUS_ACTIVE ? TASK_STATUS_ACTIVE : TASK_STATUS_INACTIVE });
        }}
      >
        {this.lbl(`vehicle.property.${name}`)}
      </Checkbox>
    );
  }

  renderApprove() {
    if (!this.state.approve) return null;

    return (
      <Modal onClose={this.reset.bind(this)} title={this.props.action.label}>
        {this.renderModalBody()}
      </Modal>
    );
  }

  renderModalBody() {
    if (this.state.loading) return <Loader />;
    return (
      <WithVehicle vehicle_id={this.vehicle.id} loader>
        <VehicleHeader vehicle={this.vehicle} />
        <div className="pane">
          
        </div>
        {this.vehicle ? (
          <VBox center>
             
              
              
              
             

          </VBox>
        ) : null}

<ModalControls>
            <PerformActionButton action={this.props.action} target={this.vehicle} onChange={this.reset.bind(this)} />
            <Button onClick={this.reset.bind(this)}>{this.lbl('cancel')}</Button>
          </ModalControls>
      </WithVehicle>
    );
  }

  render() {
    const vehicle = this.vehicle;
    const tasks = [
      'task_desticker',
      'task_nijboer',
      'task_attach_parts',
      'task_AVN',
      'task_polish_exterior',
      'task_interior_polish',
      'task_interior_repair',
      'task_int_ext_polish',
      'task_restyle',
      'task_spot_repair',
      'task_spray',
      'task_window_repair',
      'task_repair',
      'task_apk',
      'task_hartstad',
      'task_ijsseldelta',
    ];

    const vehicleTasks = tasks.filter(task => ['1', '2', '3'].includes(vehicle[task]));
    return (
      <ActionCell>
        <Container>
          <VehicleHeader vehicle={vehicle} />
          {vehicle?.show_inspection_on_sales_website == '0' || !vehicle?.show_inspection_on_sales_website && <p>Aandachtpunten accorderen </p>}
          {!vehicle?.financial_price_b2b_incl_vat_btpm && <p>B2B prijs valideren</p>}
          {vehicleTasks.length > 0 || (vehicle.task_attach_replate === '1' && vehicle.task_attach_replate_done === null) ? (
                <span className="red-text">{this.lbl('kanbanboards.cell.has_open_task')}</span>
              ) : (
                ''
              )}
          <Label count={vehicle?.valideren_counter} ranges={ranges}>
            {vehicle?.valideren_counter || '0'}
            
          </Label>
          <CellButtons>
            {this.props.cell.busy ? (
              <Loader small />
            ) : (
              <>
                <CellButton onClick={this.setStateFn({ approve: !this.state.approve })}>
                  <View />
                </CellButton>
              </>
            )}
          </CellButtons>
          {this.renderApprove()}
        </Container>
      </ActionCell>
    );
  }
}

Valideren_gijsComp.propTypes = {
  dispatch: PropTypes.func.isRequired,
};

const mapStateToProps = (state, ownProps) =>
  createStructuredSelector({
    work: selectWorks([`${REQUEST_KANBAN_BOARD_PERFORM_ACTION + ownProps.actionId}_${ownProps.cell.vehicle.id}`]),
    vehicle: selectVehicle(ownProps.cell.vehicle.id),
  });

function mapDispatchToProps(dispatch, ownProps) {
  return {
    dispatch,
    invoicePaid(invoiceId, callback) {
      dispatch(updateInvoiceStatus(invoiceId, 2, callback));
    },
  };
}

const withConnect = connect(
  mapStateToProps,
  mapDispatchToProps,
);

export const Valideren_gijs = compose(
  withConnect,
  withRouter,
)(Valideren_gijsComp);
